import { useState } from 'react'
import Input from './Input'
import { tStr } from '@utils/lang'

type ReferralInputsProps = {
  referred: boolean
  referral: {
    code: string
  }
  error?: boolean
  required?: boolean
}
const ReferralInputs = ({ referred, referral, error, required }: ReferralInputsProps) => {
  const [userInputRefCode, setUserInputRefCode] = useState('')

  if (referred) {
    return (
      <>
        <Input type="hidden" name="source" value="Runner Referral" />
        <Input type="hidden" name="source_details" value={referral.code} />
      </>
    )
  }

  return (
    <>
      <Input type="hidden" name="source" value={userInputRefCode ? 'referral' : 'no-referral'} />
      <Input
        error={error}
        label={tStr('referralLabel_s')}
        placeholder={tStr('referralPlaceholder_s')}
        name="source_details"
        id="referralCode"
        value={userInputRefCode}
        required={required}
        onChange={({ target: { value } }) => {
          setUserInputRefCode(value)
        }}
      />
    </>
  )
}

export default ReferralInputs
